import React, { useState, useEffect } from 'react';
import axios from "axios";
import { Link, withRouter, useLocation } from 'react-router-dom';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import LocalHospitalIcon from '@material-ui/icons/LocalHospital';
import {
    GridComponent, ColumnsDirective, ColumnDirective,
    Inject, Page, Filter, Sort, Edit, Toolbar
} from "@syncfusion/ej2-react-grids";
import { getValue } from '@syncfusion/ej2-base';
import { connect } from 'react-redux';
// import Popup from './Popup';

function PetProfile({ history, custInfo }) {
    let cId = custInfo.map((item) => item.custId);
    // just after login
    // const location = useLocation();        
    // if(cId == 0) {
    //     cId = location.state;
    // }
    //

    const [customerPet, setCustomerPet] = useState([]);
    // const [isOpen, setIsOpen] = useState(false);
    // const togglePopup = () => {
    //     setIsOpen(!isOpen);
    // }

    const routeChange = (petID) => {        
        window.open('https://vettriage.com/log-in/')
    }

    useEffect(() => {
        fetchPetInfo();
    }, []);

    const fetchPetInfo = () => {
        axios
            .get(`${process.env.REACT_APP_BACKEND_BASE_URL}/PetInformation/GetByCustomerId/` + cId)
            .then((response) => {
                setCustomerPet(response.data);
            });
    };

    const handleDeletePetProfile = async (petID) => {
        try {
            if (window.confirm('Are you sure you want to delete?')) {
                axios
                    .put(`${process.env.REACT_APP_BACKEND_BASE_URL}/PetInformation/Delete/` + petID)
                    .then((response) => {
                        if (response.data > 0) {
                            fetchPetInfo();
                            // alert("Deleted successfully.");
                        }
                    });
            }
        }
        catch (ex) {
            alert("Error...");
        }
    };

    const valueAccess = (field, data, column) => {
        return data[field] + ' yr, ' + getValue('ageMonth', data) + ' mo';
    };

    const template = args => {
        let src = process.env.REACT_APP_IMAGE_URL + args.imageName;
        return (<div className='pet-img'><img src={src} alt={args.petName} /></div>);
    };

    // const toolbarOptions = [
    //     "Edit", "Update", "Cancel", "Search"
    // ];
    // const filterSettings = { type: "Menu" };
    // const editSettings = { allowEditing: true, allowAdding: true, allowDeleting: true, mode: "Batch" };

    return (
        <div className="int-container">
            <div class="container">
                <div class="form-container-large" style={{ width: "100%" }}>
                    <div class="form-group">
                        <h3 style={{ color: "#f19f1f", width: "100%", textAlign: "center" }}>Pet Profile</h3>
                    </div>                    
                    <div>
                        {/* <GridComponent dataSource={customerPet} toolbar={toolbarOptions} editSettings={editSettings} height="350"> */}
                        <GridComponent dataSource={customerPet}>
                            <ColumnsDirective>
                                <ColumnDirective field="petID" headerText="Pet Id" width="50" textAlign="left" visible={false} />
                                <ColumnDirective field="petName" headerText="Pet Name" width="200px" textAlign="left" />
                                <ColumnDirective headerText="Image" template={template} width="100px" />
                                {/* <ColumnDirective width="70px"
                                    template={({ petID }) => (
                                        <button
                                            className="e-btn e-flat e-icon-btn"
                                            title="Emergency"
                                            onClick={togglePopup}
                                        ><img src="/assets/img/sos-icon.png" class="img-responsive" alt="" /></button>
                                    )}
                                /> */}
                                <ColumnDirective width="70px"
                                    template={({ petID }) => (
                                        <button                                                
                                            className="e-btn e-flat e-icon-btn"
                                            title="Emergency"
                                            onClick={() => routeChange(petID)}                                            
                                        ><img src="/assets/img/sos-icon.png" class="img-responsive" alt="" /></button>
                                    )}
                                />
                                <ColumnDirective field="ageYear" headerText="Age" width='120' textAlign="left" valueAccessor={valueAccess} />
                                <ColumnDirective field="weight" headerText="Weight(lb)" width="130" textAlign="left" />
                                <ColumnDirective width="50"
                                    template={({ petID }) => (
                                        <button
                                            className="e-icons e-edit e-btn e-flat e-icon-btn"
                                            title="Edit"
                                            onClick={() =>
                                                history.push({
                                                    pathname: '/member/update-pet-profile',
                                                    state: petID
                                                })
                                            }
                                        ></button>
                                    )}
                                />
                                <ColumnDirective width="50"
                                    template={({ petID }) => (
                                        <button
                                            className="e-icons e-delete e-btn e-flat e-icon-btn"
                                            title="Delete"
                                            onClick={() => handleDeletePetProfile(petID)}
                                        />
                                    )}
                                />
                            </ColumnsDirective>
                            {/* <Inject services={[Page, Filter, Sort, Toolbar, Edit]} />                                 */}
                        </GridComponent>
                    </div>
                    <div className="addpet">
                        <Link to={{
                            pathname: "/member/update-pet-profile",
                            state: 0
                        }}>
                            <AddCircleOutlineIcon style={{ fontSize: "40px", color: "#ef5030" }} />
                            <h5>ADD NEW PET</h5>
                            <p>Click to create profile</p>
                        </Link>
                    </div>
                </div>
            </div>
            {/* {isOpen && <Popup
                content={<>
                    <div class="row">
                        <div class="col-md-6">
                            <img src="/assets/img/veterinarian.jpg" width="70%" alt="" />
                        </div>
                        <div class="col-md-6">
                            <br /><br /><br /><br /><br />
                            <a href='#' className='btn'>Connect to Veterinarian</a>
                        </div>
                    </div>                    
                </>}
                handleClose={togglePopup}
            />} */}
        </div>
    );
}

const mapStateToProps = ({ login: { custInfo } }) => ({
    custInfo
})

export default connect(mapStateToProps)(withRouter(PetProfile));